import axiosInstance from 'services/common/axiosInstance';

export interface Course {
  id: number;
  course_name: string;
  module: number;
  description: string;
  duration: string;
  course_level: string;
  trainer: string;
  thumbnail_url: string;
  remarks: string;
  createdon: string;
  price: number;
  createdby: string;
  updatedon: string | null;
  updatedby: string | null;
  noofweek?: string;
  hourperday?: string;
  startdate?: string;
}

export interface Pagination {
  page: number;
  per_page: number;
  total_pages: number;
  total_items: number;
}

export interface CourseListResponse {
  message: string;
  data: {
    courses: Course[];
    pagination: Pagination;
  };
  success: boolean;
}

export interface GetCourseListParams {
  page: number;
  per_page: number;
  course_id: number;
  searchkey: string;
}

export interface CourseWebListParams {
  page: number;
  per_page: number;
  from_date: string;
  to_date: string;
  course_id: number;
  searchkey: string;
}

export const fetchCourseListPublic = async (
  data: GetCourseListParams
): Promise<CourseListResponse> => {
  try {
    const response = await axiosInstance.post('/course/listcourse', data);
    return response.data;
  } catch (error: any) {
    throw error.response?.data || error.message;
  }
};

export const fetchCourseListForWeb = async (
  data: CourseWebListParams
): Promise<CourseListResponse> => {
  try {
    const response = await axiosInstance.post('/course/listcourseforweb', data);
    return response.data;
  } catch (error: any) {
    throw error.response?.data || error.message;
  }
};
